import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-beneficary-instruction',
  templateUrl: './beneficary-instruction.component.html',
  styleUrls: ['./beneficary-instruction.component.scss']
})
export class BeneficaryInstructionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
